<template>
  <DashboardWindow>
    <template v-slot:title>
      {{ $t('rewards') }}
    </template>

    <template v-slot:body>
      <WCSpinner v-if="loading" size="xl" position="center" />

      <template v-else>
        <DashboardWindowSection>
          <WCLoyalty v-for="loyalty in loyaltyBalances" :key="loyalty.id" :loyalty="loyalty" />
        </DashboardWindowSection>

        <DashboardWindowSection v-if="discount">
          <h3 class="font-size-xl">{{ $t('yourCustomerDiscounts') }}</h3>
          <p class="font-size-lg">{{ discount }}</p>
        </DashboardWindowSection>

        <DashboardWindowSection v-if="coupons">
          <div class="w-75">
            <h3 class="font-size-xl">{{ $t('yourCoupons') }}</h3>
            <template v-if="coupons && coupons.length">
              <WCCoupon v-for="coupon in coupons" :key="coupon.id" :coupon="coupon" />
            </template>
            <p v-else class="font-size-lg">{{ $t('noCoupons') }}</p>
          </div>
        </DashboardWindowSection>

        <DashboardWindowSection v-if="punchCards">
          <h3 class="font-size-xl">{{ $t('yourPunchCards') }}</h3>
          <WCPunchCard v-for="card in punchCards" :key="card.ruleId" :card="card" />
        </DashboardWindowSection>
      </template>
    </template>
  </DashboardWindow>
</template>

<script>
import axios from 'axios';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCPunchCard from '@/views/Rewards/components/WCPunchCard/WCPunchCard.vue';
import WCLoyalty from '@/views/Rewards/components/WCLoyalty/WCLoyalty.vue';
import WCCoupon from '@/views/Rewards/components/WCCoupon/WCCoupon.vue';
import DashboardWindow from '@/layouts/components/Dashboard/DashboardWindow.vue';
import DashboardWindowSection from '@/layouts/components/Dashboard/DashboardWindowSection.vue';

export default {
  name: 'Rewards',
  components: {
    DashboardWindowSection,
    DashboardWindow,
    WCPunchCard,
    WCLoyalty,
    WCCoupon,
    WCSpinner,
  },
  data() {
    return {
      loading: false,
      punchCards: [],
      coupons: [],
      discount: '',
      loyaltyBalances: [],
    };
  },
  async created() {
    this.loading = true;
    try {
      this.loading = true;
      const response = await axios.get(`/api/me/rewards`);

      this.punchCards = response.data.punchCards;
      this.coupons = response.data.coupons;
      this.discount = response.data.discount;
      this.loyaltyBalances = response.data.loyaltyBalances;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped></style>
